import { Injectable, inject, signal, computed, OnDestroy } from '@angular/core';
import { AuthService } from '@ui-nuvertos/auth';
import { Subscription } from 'rxjs';

/**
 * CenterStore provides reactive access to the current center ID
 * It automatically syncs with the user session from AuthService
 */
@Injectable({
  providedIn: 'root'
})
export class CenterStore implements OnDestroy {
  private authService = inject(AuthService);
  private userSubscription?: Subscription;
  
  // Signal to track the current center ID
  private _centerId = signal<number | null>(null);

  /**
   * Get the current center ID as a signal
   * Returns null if no center is set or user is not logged in
   */
  centerId = computed(() => this._centerId());

  constructor() {
    // Initialize center ID from current user
    this.updateCenterId();

    // Subscribe to user changes via observable for reactive updates
    this.userSubscription = this.authService.currentUser$.subscribe(user => {
      this._centerId.set(user?.center_id ?? null);
    });
  }

  ngOnDestroy(): void {
    this.userSubscription?.unsubscribe();
  }

  /**
   * Update center ID from current user session
   */
  private updateCenterId(): void {
    const user = this.authService.getCurrentUser();
    this._centerId.set(user?.center_id ?? null);
  }
}
